import { useNavigate } from 'react-router-dom';
import React from "react";
import TreeIntelligenceCard from "../components/intelligence/TreeIntelligenceCard";

const GraphIntelligence = () => {
  const navigate = useNavigate();

  const openInTree = (memberId?: string) => {
    if (!memberId) {
      navigate('/app#graph');
      return;
    }

    navigate(`/app#graph`);
    setTimeout(() => {
      try {
        window.dispatchEvent(
          new CustomEvent('kc:focus-member', {
            detail: { memberId }
          })
        );

        window.dispatchEvent(
          new CustomEvent('kc:open-profile', {
            detail: {
              memberId,
              source: 'graph-intelligence'
            }
          })
        );
      } catch {}
    }, 150);
  };

  if (typeof window !== "undefined") {
    (window as any).__KINSCIRCLE_INTELLIGENCE__ = true;
  }
  return (
    <main className="min-h-screen bg-slate-50 px-4 py-6">
      <div className="mx-auto max-w-5xl space-y-4">
        <section className="rounded-2xl border bg-white p-5 shadow-sm">
          <p className="text-xs font-semibold uppercase tracking-wide text-fuchsia-600">
            KinsCircle OS
          </p>
          <h1 className="mt-1 text-2xl font-bold text-slate-950">
            Graph Intelligence
          </h1>
          <p className="mt-2 text-sm text-slate-600">
            Live tree-health diagnostics, repair proposals, duplicate risks,
            orphaned nodes, invite sync, mutation audits, and recovery history.
          </p>
        </section>

        <TreeIntelligenceCard
        onFindInTree={(memberId) => openInTree(memberId)}
        onOpenProfile={(memberId) => openInTree(memberId)}
      />
      </div>
    </main>
  );
};

export default GraphIntelligence;
